// Alert
jQuery(function($) {
  $('.alert__close').on('click', function(e) {
    $('.alert').remove();
    e.preventDefault();
  });
});
